import { render, staticRenderFns } from "./BloodTransfusionToolbar.vue?vue&type=template&id=4448d115&"
import script from "./BloodTransfusionToolbar.vue?vue&type=script&lang=js&"
export * from "./BloodTransfusionToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BloodTransfusionToolbar.vue?vue&type=style&index=0&id=4448d115&prod&lang=scss&"
import style1 from "./BloodTransfusionToolbar.vue?vue&type=style&index=1&id=4448d115&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports